$(function () {

  // hamburger menu
  $(".hamburger-menu").on("click", function () {
      $(".cwr-main-header__col nav").slideToggle();
  });
  if($(window).width() < 1200){
    $(".cwr-main-header__col nav .sub-menu .mobile-svg").on("click", function () {
        if ($(".cwr-main-header__col nav").css("display") === "block") {
            $(".sub-menu__inner").slideToggle();
            $(this).toggleClass("open-menu");
        }
    });
  }
  // end hamburger menu

  // usp slider
  let uspSlider = {   
      speed: 7000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      mobileFirst: true,
      lazyLoad: 'ondemand',
      responsive: [
          {
              breakpoint: 992,
              settings: 'unslick'
          },
      ]
  }
  var winUspSlider = $(window);
  var sliderUspSlider = $(".js-usp-main-slider");

  winUspSlider.on("load resize", function () {
      if (winUspSlider.width() < 992) {
          sliderUspSlider.not(".slick-initialized").slick(uspSlider);
      } else if (sliderUspSlider.hasClass("slick-initialized")) {
          sliderUspSlider.slick("unslick");
      }
  });
  // end usp slider

  // our best sellers
  if ($(".js-our-best-sellers-slider").length > 0) {
      $(".js-our-best-sellers-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: '250px',
        centerMode: true,
        lazyLoad: 'ondemand',
        prevArrow: $(".js-our-best-sellers-prev"),
        nextArrow: $(".js-our-best-sellers-next"),
        appendDots: $('.js-our-best-sellers-dot'),
        responsive: [
          {
            breakpoint: 1536,
            settings: {
              slidesToShow: 4,
              arrows: true,
              dots: true,
            },
          },
          {
              breakpoint: 1360,
              settings: {
                  slidesToShow: 3,
                  centerPadding: '150px',
              },
            },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              centerPadding: '100px',
            },
          },
          {
            breakpoint: 821,
            settings: {
              slidesToShow: 1,
              centerPadding: '150px',
            },
          },
          {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                centerPadding: '25px',
              },
          },
        ],
      });
  }      
  // end our best sellers

  // matchHeight
  if($('.our-best-sellers__slider-item-box .desc h6').length > 0){
    $('.our-best-sellers__slider-item-box .desc h6').matchHeight({
        byRow: 0,
    });
  }
  if($('.shop-by-solution__item-box p').length > 0){
    $('.shop-by-solution__item-box p').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__heading-item .col1').length > 0){
    $('.compare-diffrence__heading-item .col1').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col2').length > 0){
    $('.compare-diffrence__item .col2').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col3').length > 0){
    $('.compare-diffrence__item .col3').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col4').length > 0){
    $('.compare-diffrence__item .col4').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col5').length > 0){
    $('.compare-diffrence__item .col5').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col6').length > 0){
    $('.compare-diffrence__item .col6').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col7').length > 0){
    $('.compare-diffrence__item .col7').matchHeight({
        byRow: 0,
    });
  }
  // end matchHeight

  // Shop by Solution slider
  let shopBySlider = {   
      dots: false,
      infinite: true,       
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: 2,
      autoplay: true,
      arrows: false,
      centerMode: true,
      lazyLoad: 'ondemand',
      centerPadding: '0px',
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
              }
          },
      ]
  }
  var winShopBySliderSlider = $(window);
  var sliderShopBy = $(".js-shop-by-solution-slider");

  winShopBySliderSlider.on("load resize", function () {
      if (winShopBySliderSlider.width() >= 992) {
          sliderShopBy.not(".slick-initialized").slick(shopBySlider);
      } else if (sliderShopBy.hasClass("slick-initialized")) {
          sliderShopBy.slick("unslick");
      }
  });
  // end Shop by Solution slider

  // you can find us
  if ($(".js-you-can-find-us-slider").length > 0) {
    $(".js-you-can-find-us-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      lazyLoad: "ondemand",
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      slidesToScroll: 1,
    });
  }
  // end you can find us

  // our our reputation slider
  if ($(".js-our-reputation-slider").length > 0) {
    $(".js-our-reputation-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      centerMode: false,
      arrows: true,
      dots: true,
      lazyLoad: 'ondemand',
      prevArrow: $(".js-our-reputation-prev"),
      nextArrow: $(".js-our-reputation-next"),
      appendDots: $('.js-our-reputation-dot'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '130px',
          },
        },
        {
          breakpoint: 821,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '130px',
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '80px',
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px',
          },
        },
      ],
    });
}      
// end our reputation slider

// feature marquee
if ($(".js-feature-marquee").length > 0){
  $('.js-feature-marquee').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 100,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 0,
    arrows: false,
    buttons: false
  });
}
// end feature marquee

// as seen on clients
if ($(".js-as-seen-on-clients").length > 0) {
  $(".js-as-seen-on-clients").slick({
    dots: false,
    arrows: false,
    infinite: true,
    lazyLoad: "progressive",
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: true,
    slidesToScroll: 1,
  });
}
// end as seen on clients

// accordian 
var action="click";
var speed="500";

$('.faq__item-question').on(action, function() {
    $(this).parent().siblings().find('.faq__item-answer').slideUp();
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle(speed);
});
// end accordian

// insta in heading icon
let headingIcon = `<img class="img-fluid" src="//www.petsmont.com/cdn/shop/files/cwr-pet-icon.png?v=1729070552" alt="icon" width="32" height="32">`;
$(headingIcon).insertBefore(".cwr-instafeed--new .cwr-instafeed__inner .ooo-instagram-header h2");
});